import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Heart, Lock } from 'lucide-react';
interface PilotSlide2FProps {
  isDark?: boolean;
}
export function PilotSlide2F({
  isDark = false
}: PilotSlide2FProps) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  // Theme colors
  const bgColor = isDark ? 'bg-orange-900/20' : 'bg-[#fcebd9]';
  const textColor = isDark ? 'text-white' : 'text-heliona-charcoal';
  const subTextColor = isDark ? 'text-white/70' : 'text-heliona-text-gray';
  const iconColor = isDark ? 'text-orange-300' : 'text-orange-600';
  const labelColor = isDark ? 'text-white/60' : 'text-gray-500';
  return <motion.div className={`h-full w-full overflow-y-auto overflow-x-hidden ${bgColor}`} variants={containerVariants} initial="hidden" animate="visible" data-id="element-630">
      <div className="min-h-full flex flex-col justify-center items-center max-w-6xl mx-auto px-6 sm:px-12 py-16 sm:py-20" data-id="element-631">
        {/* Shared Header */}
        <motion.div variants={itemVariants} className="text-center mb-10 sm:mb-12" data-id="element-632">
          <p className={`text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase mb-2 ${labelColor}`} data-id="element-633">
            What Heliona Offers
          </p>
          <h1 className={`text-xl sm:text-2xl font-serif font-medium tracking-tight ${textColor}`} data-id="element-634">
            An integrated leadership wellness pipeline
          </h1>
        </motion.div>

        {/* Product Content */}

        {/* Browser Mockup */}
        <motion.div variants={itemVariants} className="w-full max-w-5xl relative z-10" data-id="element-635">
          <div className="rounded-2xl overflow-hidden shadow-2xl bg-[#2a2f3a] border border-white/10" data-id="element-636">
            {/* Browser Chrome */}

            {/* Screenshot */}
            <div className="relative aspect-[16/9] w-full bg-[#1a1d24]" data-id="element-637">
              <img src="https://cdn.magicpatterns.com/uploads/3n6aSd6Zz1jYMoabCLypgh/Screenshot_2026-02-05_at_3.19.12_PM.png" alt="Helium Care Dashboard" className="w-full h-full object-cover" data-id="element-638" />
            </div>
          </div>
        </motion.div>
      </div>
    </motion.div>;
}